class ClientComputer {
  constructor(uniqueId, note, extensionId, zoneId, title) {
    this.uniqueId = uniqueId;
    this.note = note;
    this.extensionId = extensionId;
    this.zoneId = zoneId;
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      clientComputerId: null,
      searchTitle: '',
      selectedCity: null,
      disabelConfirm: false,
      addFlag: false,
      isActive: false,
      isConfirmed: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,
      modalIcon: '',
      clientComputerManagmentInformationTableHeaders: [
        { text: 'نام کامپیوتر', value: 'title', align: 'center' },
        { text: 'شناسه', value: 'uniqueId', align: 'center' },
        { text: 'داخلی', value: 'extension', align: 'center' },
        { text: 'شهر', value: 'city', align: 'center' },
        { text: 'ناحیه', value: 'zone', align: 'center' },
        { text: 'توضیح', value: 'note', align: 'center' },
        { text: 'وضعیت', value: 'status', align: 'center' },
        { text: 'فعال-غیرفعال', value: 'active', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      searchExtensionId: null,
      searchZoneId: null,
      searchCityId: null,
      searchUniqueId: null,
      searchComputerTitle: null,
      validateuniqueId: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن کامپیوتر';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش کامپیوتر';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getClientComputerFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.isActive = false;
      this.isConfirmed = false;
      this.selectedCity = null;
      this.clientComputer = new ClientComputer('', '', null, null, '');
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addClientComputerFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش کامپیوتر';
        this.$refs.confirm.text = 'از ویرایش کامپیوتر اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف کامپیوتر';
        this.$refs.confirm.text = 'از حذف کامپیوتر اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addClientComputerFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editClientComputerFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteClientComputerFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    cityChange: function () {
      this.clientComputer.zoneId = null;
      this.clientComputer.extensionId = null;
      if (this.selectedCity) {
        this.getListOfZonesForOther(this.selectedCity);
        this.getListOfExtensionsForOther(this.selectedCity);
      }
    },
    searchCityChange: function () {
      this.searchZoneId = null;
      this.searchExtensionId = null;
      if (this.searchCityId) {
        this.getListOfZonesForOther(this.searchCityId);
        this.getListOfExtensionsForOther(this.searchCityId);
      }
    },
    cityChange2: function () {
      if (this.selectedCity) {
        this.getListOfZonesForOther(this.selectedCity);
        this.getListOfExtensionsForOther(this.selectedCity);
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.clientComputerId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    //search
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfClientComputersWithPagination();
    },
    removeFilters: function () {
      this.searchExtensionId = null;
      this.searchZoneId = null;
      this.searchCityId = null;
      this.searchUniqueId = null;
      this.searchComputerTitle = null;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfClientComputersWithPagination();
    },
    cancelSearch: function () {
      this.searchExtensionId = null;
      this.searchZoneId = null;
      this.searchCityId = null;
      this.searchUniqueId = null;
      this.searchModal = false;
    },
  },
};
